export { default } from '@esentai/core/features/kkms/api';
